/* ============================================================
   +CARTON Theme — theme.js
   Cart, accordions, countdown, misc utilities
   ============================================================ */

/* ---- Cart ------------------------------------------------- */
class CartAPI {
  static async add(items) {
    const res = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error('Cart add failed');
    return res.json();
  }

  static async get() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  static async change(id, quantity) {
    const res = await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id, quantity })
    });
    return res.json();
  }
}

/* ---- Cart count badge ------------------------------------- */
async function refreshCartCount() {
  try {
    const cart = await CartAPI.get();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch (_) {}
}

document.addEventListener('DOMContentLoaded', refreshCartCount);

/* ---- Add to cart ------------------------------------------ */
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action="/cart/add"]');
  if (!form) return;
  e.preventDefault();

  const btn = form.querySelector('[type="submit"]');
  const originalText = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = '<span class="spinner"></span>';

  try {
    const formData = new FormData(form);
    await CartAPI.add([{
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity') || '1', 10)
    }]);
    await refreshCartCount();
    btn.innerHTML = '✓ Added!';
    btn.style.background = 'var(--color-success)';
    setTimeout(() => {
      btn.innerHTML = originalText;
      btn.style.background = '';
      btn.disabled = false;
    }, 2000);
  } catch (err) {
    btn.innerHTML = 'Error — try again';
    btn.style.background = 'var(--color-error)';
    setTimeout(() => {
      btn.innerHTML = originalText;
      btn.style.background = '';
      btn.disabled = false;
    }, 2000);
  }
});

/* ---- Accordion -------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      const content = trigger.nextElementSibling;
      content.classList.toggle('open', !expanded);
    });
  });
});

/* ---- Countdown Timer -------------------------------------- */
function initCountdown(el) {
  const end = new Date(el.dataset.end).getTime();
  if (isNaN(end)) return;

  function tick() {
    const diff = end - Date.now();
    if (diff <= 0) { el.textContent = 'Expired'; return; }
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    el.textContent = `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
  }
  tick();
  setInterval(tick, 1000);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-countdown]').forEach(initCountdown);
});

/* ---- Swiper init ------------------------------------------ */
document.addEventListener('DOMContentLoaded', () => {
  // Deals carousel
  document.querySelectorAll('.swiper-deals').forEach(el => {
    new Swiper(el, {
      slidesPerView: 1.2, spaceBetween: 16, grabCursor: true,
      pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
      breakpoints: {
        640:  { slidesPerView: 2.2 },
        1024: { slidesPerView: 3.5 }
      }
    });
  });

  // Products carousel
  document.querySelectorAll('.swiper-products').forEach(el => {
    new Swiper(el, {
      slidesPerView: 1.5, spaceBetween: 16, grabCursor: true,
      navigation: { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') },
      breakpoints: {
        480:  { slidesPerView: 2.2 },
        768:  { slidesPerView: 3.2 },
        1024: { slidesPerView: 4.5 }
      }
    });
  });

  // Testimonials carousel
  document.querySelectorAll('.swiper-testimonials').forEach(el => {
    new Swiper(el, {
      slidesPerView: 1, spaceBetween: 24, grabCursor: true, loop: true,
      autoplay: { delay: 5000, disableOnInteraction: false },
      pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
      breakpoints: {
        768:  { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  });
});

/* ---- Price Calculator ------------------------------------- */
class PriceCalculator {
  constructor(form) {
    this.form = form;
    this.tiers = JSON.parse(form.dataset.tiers || '[]');
    this.basePrice = parseFloat(form.dataset.basePrice || '0');
    this.currency = form.dataset.currency || 'RM';
    this.priceEl = form.querySelector('[data-price-total]');
    this.unitEl  = form.querySelector('[data-price-unit]');
    this.qtyInput = form.querySelector('[name="quantity"]');

    if (this.qtyInput) {
      this.qtyInput.addEventListener('change', () => this.update());
    }
    form.querySelector('[name="id"]')?.addEventListener('change', () => this.update());
    this.update();
  }

  getUnitPrice(qty) {
    let price = this.basePrice;
    for (const tier of this.tiers) {
      if (qty >= tier.min_qty) price = tier.price;
    }
    return price;
  }

  update() {
    const qty = parseInt(this.qtyInput?.value || '1', 10);
    const unit = this.getUnitPrice(qty);
    const total = unit * qty;
    if (this.unitEl)  this.unitEl.textContent  = `${this.currency} ${unit.toFixed(2)} / pc`;
    if (this.priceEl) this.priceEl.textContent = `${this.currency} ${total.toFixed(2)}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-price-calculator]').forEach(form => {
    new PriceCalculator(form);
  });
});

/* ---- Quantity selector ------------------------------------ */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.qty-selector__btn');
  if (!btn) return;
  const input = btn.closest('.qty-selector').querySelector('.qty-selector__input');
  let val = parseInt(input.value, 10) || 1;
  const min = parseInt(input.min || '1', 10);
  const max = parseInt(input.max || '9999', 10);
  if (btn.dataset.action === 'increase') val = Math.min(val + 1, max);
  if (btn.dataset.action === 'decrease') val = Math.max(val - 1, min);
  input.value = val;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* ---- Sample pack builder ---------------------------------- */
function initSampleBuilder() {
  const builder = document.querySelector('[data-sample-builder]');
  if (!builder) return;
  const MAX = 8;
  const countEl = builder.querySelector('[data-sample-count]');

  builder.addEventListener('change', e => {
    const cb = e.target;
    if (cb.type !== 'checkbox') return;
    const checked = builder.querySelectorAll('input[type="checkbox"]:checked');
    if (checked.length > MAX) { cb.checked = false; return; }
    if (countEl) countEl.textContent = checked.length;
    builder.querySelectorAll('input[type="checkbox"]:not(:checked)').forEach(c => {
      c.disabled = checked.length >= MAX;
    });
  });
}

document.addEventListener('DOMContentLoaded', initSampleBuilder);

/* ---- Cookie banner ---------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector('.cookie-banner');
  if (!banner) return;
  if (localStorage.getItem('cookies-accepted')) { banner.remove(); return; }
  banner.style.display = 'flex';
  banner.querySelector('[data-accept]')?.addEventListener('click', () => {
    localStorage.setItem('cookies-accepted', '1');
    banner.remove();
  });
});

/* ---- Newsletter popup ------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('.newsletter-popup-overlay');
  if (!popup) return;
  if (sessionStorage.getItem('newsletter-shown')) { popup.remove(); return; }
  setTimeout(() => {
    popup.style.display = 'flex';
    sessionStorage.setItem('newsletter-shown', '1');
  }, 8000);
  popup.querySelector('[data-close]')?.addEventListener('click', () => popup.remove());
  popup.addEventListener('click', e => { if (e.target === popup) popup.remove(); });
});

/* ---- Copy coupon code ------------------------------------- */
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-copy-code]');
  if (!btn) return;
  const code = btn.dataset.copyCode;
  navigator.clipboard.writeText(code).then(() => {
    const orig = btn.textContent;
    btn.textContent = 'Copied!';
    setTimeout(() => btn.textContent = orig, 2000);
  });
});

/* ---- Mobile menu toggle (for header) ---------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu   = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;
  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('open');
    toggle.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  });
});
